import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { zodParseWithLog } from "src/api/apiErrorLogs";
import { PostSchema } from "./postSchema";
import axios from "axios";
import { OlapScoresQuery } from "src/context/OlapScores/useOlapScoresParams";

export const getPackagingPostKey = "getPackagingPost" as const;

type Options = {
    packagingId: number | undefined;
    companyId?: number;
    campaignId?: number;
    scoresQuery?: OlapScoresQuery;
    enabled?: boolean;
};

export const useGetPackagingPost = (options: Options) => {
    const { packagingId, companyId, campaignId, enabled = true, scoresQuery } = options;
    const isEnabled = enabled && packagingId !== undefined && companyId !== undefined && campaignId !== undefined;

    const query = useQuery({
        queryKey: [getPackagingPostKey, packagingId, companyId, campaignId, scoresQuery],
        cacheTime: 0,
        enabled: isEnabled,
        queryFn: () => fetchPackagingPost(packagingId, companyId, campaignId, scoresQuery),
        select: (response) => {
            if (!response) {
                return;
            }

            const post = response.data;
            const data = zodParseWithLog(post, PostSchema, getPackagingPostKey);
            return data;
        },
    });

    return {
        post: query.data,
        ...query,
    };
};

export const fetchPackagingPost = async (
    packagingId: number | undefined,
    companyId: number | undefined,
    campaignId: number | undefined,
    scoresQuery?: OlapScoresQuery,
) => {
    const url = `/api/packagings/${packagingId}/ssq-post`;

    try {
        return await loggedInApiCall.get(url, {
            headers: {
                Accept: "application/json",
            },
            params: {
                organization_id: companyId ?? undefined,
                campaign: campaignId ?? undefined,
                ...scoresQuery,
            },
        });
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
            return null;
        }
        throw error;
    }
};
